<template>
  <div class="survey-form">
    <h4 class="size-16 fw-600 text-dark mb-3">Paso 3: Datos del producto del competidor</h4>
    <div class="bg-white rounder-8 border p-4">
      <div class="row g-3">
        <div class="col-12 col-md-6">
          <label class="form-label size-14 fw-400">SKU del competidor</label>
          <input
            type="text"
            class="form-control py-2 rounder-8"
            v-model="localForm.competitor_sku"
            placeholder="Opcional"
          />
        </div>

        <div class="col-12 col-md-6">
          <label class="form-label size-14 fw-400">
            Nombre del producto en competidor <span class="text-danger">*</span>
          </label>
          <input
            type="text"
            class="form-control py-2 rounder-8"
            :class="{ 'is-invalid': errors.competitor_product_name }"
            v-model="localForm.competitor_product_name"
            placeholder="Ej: TV Samsung 55 pulgadas"
          />
          <div v-if="errors.competitor_product_name" class="invalid-feedback size-12">
            {{ errors.competitor_product_name }}
          </div>
        </div>

        <div class="col-12 col-md-6">
          <label class="form-label size-14 fw-400">
            Precio lista <span class="text-danger">*</span>
          </label>
          <input
            type="number"
            min="0"
            step="0.01"
            class="form-control py-2 rounder-8"
            :class="{ 'is-invalid': errors.competitor_original_price }"
            v-model.number="localForm.competitor_original_price"
            placeholder="0.00"
          />
          <div v-if="errors.competitor_original_price" class="invalid-feedback size-12">
            {{ errors.competitor_original_price }}
          </div>
        </div>

        <div class="col-12 col-md-6">
          <label class="form-label size-14 fw-400">
            Precio descuento <span class="text-danger">*</span>
          </label>
          <input
            type="number"
            min="0"
            step="0.01"
            class="form-control py-2 rounder-8"
            :class="{ 'is-invalid': errors.competitor_sale_price }"
            v-model.number="localForm.competitor_sale_price"
            placeholder="0.00"
          />
          <div v-if="errors.competitor_sale_price" class="invalid-feedback size-12">
            {{ errors.competitor_sale_price }}
          </div>
        </div>

        <div class="col-12">
          <div class="form-check">
            <input
              id="stockCheck"
              type="checkbox"
              class="form-check-input"
              v-model="localForm.competitor_stock"
            />
            <label class="form-check-label size-14 fw-400" for="stockCheck">
              Stock disponible
            </label>
          </div>
        </div>

        <div class="col-12 d-flex flex-column flex-sm-row gap-2 justify-content-center justify-content-sm-end mt-3">
          <button
            type="button"
            class="btn btn-primary fw-400 rounder-8 px-4 w-100 w-sm-auto"
            @click="handleClear"
            :disabled="loading"
          >
            Limpiar
          </button>
          <button
            type="button"
            class="btn bgc-dark text-white rounder-8 px-4 w-100 w-sm-auto"
            @click="handleSave"
            :disabled="loading"
          >
            <span v-if="loading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
            Guardar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SurveyForm',
  props: {
    value: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    localForm: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    handleSave() {
      this.$emit('save')
    },
    handleClear() {
      this.$emit('clear')
    }
  }
}
</script>

<style scoped>
.bgc-dark:hover {
  background-color: #09090B !important;
}

.btn:hover{
  font-weight: 400 !important;
}

@media (min-width: 576px) {
  .w-sm-auto {
    width: auto !important;
  }
}
</style>
